const activeClass = "slider-paginate__item--active";
const timeSlide = 8000;

const removeActiveClass = () => {
  $(`.slider-paginate__item`).each((_, item) => {
    $(item).removeClass(activeClass);
  });
};
const initLoop = (swiper) => {
  return setInterval(() => {
    removeActiveClass();
    swiper.slideNext();
  }, timeSlide);
};

const animateCircle = (circle) => {
  circle.style["stroke-dasharray"] = "1000";
  circle.style["stroke-dashoffset"] = "1000";
  let offset = 1000;
  var start;

  function animate(timestamp) {
    if (!start) start = timestamp + timeSlide;
    var progress = start - timestamp;

    // 250 / 60 volte al secondo  = 4.166666667
    offset -= 4.15;
    circle.style["stroke-dashoffset"] = offset;

    if (progress > 0) {
      requestAnimationFrame(animate);
    } else {
      console.timeEnd("start");
    }
  }

  requestAnimationFrame(animate);
};

export const sliderHeroV1 = {
  bindEvents: (el, swiper) => {
    jQuery(function($) {
      let intervalId = null,
        prev = null;

      // $(".slider-paginate__item").click(function(e) {
      //   const index = +this.getAttribute("data-id");
      //   swiper.slideTo(index);
      // });

      const index = swiper.realIndex;
      const item = $(`.slider-paginate__item[data-id='${index}']`);
      const circle = item.find(".circle")[0];

      item.addClass(activeClass);

      intervalId = initLoop(swiper);

      swiper.on("slideChange", function() {
        clearInterval(intervalId);
        removeActiveClass();

        const nextIndex = swiper.realIndex;
        if (prev === nextIndex) return;
        prev = nextIndex;

        const nextItem = $(`.slider-paginate__item[data-id='${nextIndex}']`);
        nextItem.addClass(activeClass);

        intervalId = initLoop(swiper);
      });
    });
  },
  elements: Array.from(
    document.querySelectorAll(".slider-hero--v1 .swiper-container")
  ),
  details: (el) => ({
    // Optional parameters
    // cssMode: true,
    // centeredSlides: true,
    // loopedSlides: 5,
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    speed: 2000,
    threshold: 10,
    resistance: false,

    // longSwipesRatio: 2,
    // Disable preloading of all images
    // preloadImages: false,
    // Enable lazy loading
    lazy: true,
    // updateOnWindowResize: true,

    // If we need pagination
    // pagination: {
    //   el: el.querySelector(".swiper-pagination"),
    // },
    // Navigation arrows
    navigation: {
      nextEl: el.querySelector(".swiper-button-next"),
      prevEl: el.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      // 1023: {
      //   slidesPerView: 1,
      //   spaceBetween: 40,
      // },
      // 767: {
      //   slidesPerView: 1,
      //   spaceBetween: 20,
      // },
      // 640: {
      //   slidesPerView: 1,
      //   spaceBetween: 20,
      // },
    },
  }),
};
